/****************************************************
 * Module Name:  deleteProformaModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import DeleteIcon from "@mui/icons-material/Delete";

function DeleteProformaModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  proformaIds,
  deleteModalTitle,
  loading,
}) {
  const [showError, setShowError] = useState(false);

  const saveHandler = () => {
    let data = proformaIds;
    let message =
      deleteModalTitle === "Are you sure you want to Delete these stones ?"
        ? "Stones Deleted Successfully"
        : "Proforma Deleted Successfully";
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data, message);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data, message);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Delete Proforma validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {deleteModalTitle ===
              "Are you sure you want to Delete these stones ?"
              ? "Delete Stone(s)"
              : "Delete Proforma"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            {deleteModalTitle}
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            variant="contained"
            onClick={saveHandler}
            type="Submit"
            sx={{ mr: 3 }}
            loading={loading}
            loadingPosition="start"
            startIcon={<DeleteIcon />}
          >
            Delete
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DeleteProformaModal;
